import React from "react"

export default function HowToPlay() {
    return <>TBD</>
}